import {Helmet} from '@dr.pogodin/react-helmet';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {formatDocumentTitle} from '@dms/shared';

import {ParkingDataGrid} from './components/ParkingDataGrid';

export function VehicleParking() {
  return (
    <>
      <Helmet
        title={formatDocumentTitle(
          i18n.t('page.vehicleSettings.labels.parking'),
          i18n.t('page.settings.labels.title')
        )}
      />
      <SettingsTemplate
        header={{title: i18n.t('page.vehicleSettings.labels.parking')}}
        description={i18n.t('page.vehicleSettings.labels.parkingDescription')}
        data-testid={testIds.settings.vehicleParking('modal')}
      >
        <ParkingDataGrid />
      </SettingsTemplate>
    </>
  );
}
